import type { FC } from "react";

import type { FlowCustomComponentProps } from "@/shared/constants/flowTypes";

import { PropertyLoanForm, MORTGAGE_CONFIG } from "./PropertyLoanForm";

interface PropertyMortgageProps extends FlowCustomComponentProps {
  propertyId: number;
}

export const PropertyMortgage: FC<PropertyMortgageProps> = (props) => (
  <PropertyLoanForm {...props} config={MORTGAGE_CONFIG} />
);
